module.exports = __webpack_public_path__ + "img/icon-white.3d15ad1e.png";